import React from 'react';
import firebase from '../../firebase/firebase.utils';
import './materijal.style.scss';


class MaterijalPPZiBZNR extends React.Component{
  constructor(props){
    super(props);
    this.state={
      materijal2:[],
    };
  };


componentDidMount(){
  const materijal2Ref=firebase.database().ref('materijalPPZiBZNR');
  materijal2Ref.on('value',(snapshot)=>{
    let materijal2=snapshot.val();
    let newState=[];
    for (let materijalUrl in materijal2){
      newState.push({
        id:materijalUrl,
        materijalUrl:materijal2[materijalUrl].materijalUrl,
        materijalName:materijal2[materijalUrl].materijalName
      });
    }
    this.setState({
      materijal2:newState
    });
  });
}
render(){
  return(
<div className='materijal-component'>
<h2 >МАТЕРИЈАЛ ЗА ПОЛАГАЊЕ
</h2>
<div className='materijal-container' >

{
  this.state.materijal2.map((materijalUrl)=>{
    return(
    
        <a className='materijal-list-component' key={materijalUrl.materijalName}  href={materijalUrl.materijalUrl} alt='test' target="_blank" rel="noopener noreferrer" >  {materijalUrl.materijalName} </a>
 
     
    );
  })
}
  </div>

</div>
  );
}

}

export default MaterijalPPZiBZNR;